"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeHandleCriticalErrorWithHistory = exports.maybeHandleCriticalError = void 0;
var _CriticalErrorHandlersStorage = require("../CriticalErrorHandlersStorage");
var maybeHandleCriticalError = exports.maybeHandleCriticalError = function maybeHandleCriticalError(location, globalErrors, redirectFunction) {
  if (globalErrors) {
    var availableCriticalErrorCodes = _CriticalErrorHandlersStorage.criticalErrorHandlersStorage.getCriticalErrorCodes();
    var errors = Array.isArray(globalErrors) ? globalErrors : [globalErrors];
    for (var i = 0; i < errors.length; i++) {
      var _errors$i = errors[i],
        code = _errors$i.code,
        params = _errors$i.params;
      if (availableCriticalErrorCodes.includes(code)) {
        var criticalErrorsHandlers = _CriticalErrorHandlersStorage.criticalErrorHandlersStorage.getErrorHandlers()(location, redirectFunction);
        criticalErrorsHandlers[code](params);
        return true;
      }
    }
  }
  return false;
};
var maybeHandleCriticalErrorWithHistory = exports.maybeHandleCriticalErrorWithHistory = function maybeHandleCriticalErrorWithHistory(_ref, globalErrors) {
  var location = _ref.location,
    push = _ref.push;
  return maybeHandleCriticalError(location, globalErrors, push);
};